import {
  IJob,
  indexAddToAdminCareerPage,
  updateAddToCareerPage,
  IAppContext as CareerPageSettings,
} from 'wisestep-api';

export const indexJob = (job: IJob, careerPageSetting: CareerPageSettings | null) => {
  if (careerPageSetting?.userId && !job.addToCareerPage) {
    indexAddToCareerPages(job?.id ?? '');
  } else if (!careerPageSetting?.userId && !job.addJobToAdminCareerPage) {
    indexAddToAdminCareerPages(job?.id ?? '');
  }
};

const socialMediaShareUrl = (
  job: IJob | undefined,
  careerPageSetting: CareerPageSettings | null
): string => {
  let domain = '';
  if (careerPageSetting?.userId) {
    if (careerPageSetting.domain) {
      domain = `https://${careerPageSetting.domain}/${job?.id}`;
    } else {
      domain = `https://careerpages.wisestep.com/${careerPageSetting.slug}/${job?.id}/apply?utm_source=email`;
    }
  } else {
    domain = `https://careerpages.wisestep.com/jobs/${job?.id}`;
  }
  return domain;
};

export default socialMediaShareUrl;

export const indexAddToAdminCareerPages = async (jobId: string) =>
  indexAddToAdminCareerPage(jobId, true);

export const indexAddToCareerPages = async (jobId: string) => updateAddToCareerPage(jobId, true);
